function cov_bjamgzyl() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Select/shared.tsx";
  var hash = "0812619bc7eaa935fa341ae5abceb91ad8caa6c4";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Select/shared.tsx",
    statementMap: {
      "0": {
        start: {
          line: 13,
          column: 37
        },
        end: {
          line: 13,
          column: 66
        }
      },
      "1": {
        start: {
          line: 14,
          column: 27
        },
        end: {
          line: 14,
          column: 61
        }
      },
      "2": {
        start: {
          line: 16,
          column: 33
        },
        end: {
          line: 30,
          column: 1
        }
      },
      "3": {
        start: {
          line: 22,
          column: 2
        },
        end: {
          line: 24,
          column: 3
        }
      },
      "4": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 23,
          column: 26
        }
      },
      "5": {
        start: {
          line: 26,
          column: 2
        },
        end: {
          line: 28,
          column: 3
        }
      },
      "6": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 17
        }
      },
      "7": {
        start: {
          line: 29,
          column: 2
        },
        end: {
          line: 29,
          column: 14
        }
      },
      "8": {
        start: {
          line: 32,
          column: 20
        },
        end: {
          line: 40,
          column: 1
        }
      },
      "9": {
        start: {
          line: 33,
          column: 2
        },
        end: {
          line: 37,
          column: 3
        }
      },
      "10": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 34,
          column: 16
        }
      },
      "11": {
        start: {
          line: 35,
          column: 9
        },
        end: {
          line: 37,
          column: 3
        }
      },
      "12": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 36,
          column: 40
        }
      },
      "13": {
        start: {
          line: 39,
          column: 2
        },
        end: {
          line: 39,
          column: 38
        }
      },
      "14": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 108,
          column: 1
        }
      },
      "15": {
        start: {
          line: 66,
          column: 20
        },
        end: {
          line: 66,
          column: 43
        }
      },
      "16": {
        start: {
          line: 68,
          column: 2
        },
        end: {
          line: 107,
          column: 4
        }
      },
      "17": {
        start: {
          line: 110,
          column: 70
        },
        end: {
          line: 121,
          column: 1
        }
      },
      "18": {
        start: {
          line: 111,
          column: 23
        },
        end: {
          line: 111,
          column: 63
        }
      },
      "19": {
        start: {
          line: 112,
          column: 2
        },
        end: {
          line: 120,
          column: 4
        }
      },
      "20": {
        start: {
          line: 123,
          column: 34
        },
        end: {
          line: 128,
          column: 2
        }
      },
      "21": {
        start: {
          line: 130,
          column: 29
        },
        end: {
          line: 209,
          column: 2
        }
      },
      "22": {
        start: {
          line: 134,
          column: 34
        },
        end: {
          line: 209,
          column: 1
        }
      },
      "23": {
        start: {
          line: 143,
          column: 4
        },
        end: {
          line: 165,
          column: 6
        }
      },
      "24": {
        start: {
          line: 174,
          column: 4
        },
        end: {
          line: 189,
          column: 6
        }
      },
      "25": {
        start: {
          line: 198,
          column: 4
        },
        end: {
          line: 207,
          column: 6
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 16,
            column: 33
          },
          end: {
            line: 16,
            column: 34
          }
        },
        loc: {
          start: {
            line: 20,
            column: 13
          },
          end: {
            line: 30,
            column: 1
          }
        },
        line: 20
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 32,
            column: 20
          },
          end: {
            line: 32,
            column: 21
          }
        },
        loc: {
          start: {
            line: 32,
            column: 77
          },
          end: {
            line: 40,
            column: 1
          }
        },
        line: 32
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 54,
            column: 4
          },
          end: {
            line: 54,
            column: 5
          }
        },
        loc: {
          start: {
            line: 65,
            column: 6
          },
          end: {
            line: 108,
            column: 1
          }
        },
        line: 65
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 110,
            column: 70
          },
          end: {
            line: 110,
            column: 71
          }
        },
        loc: {
          start: {
            line: 110,
            column: 81
          },
          end: {
            line: 121,
            column: 1
          }
        },
        line: 110
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 130,
            column: 29
          },
          end: {
            line: 130,
            column: 30
          }
        },
        loc: {
          start: {
            line: 134,
            column: 34
          },
          end: {
            line: 209,
            column: 1
          }
        },
        line: 134
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 142,
            column: 10
          },
          end: {
            line: 142,
            column: 11
          }
        },
        loc: {
          start: {
            line: 142,
            column: 21
          },
          end: {
            line: 166,
            column: 3
          }
        },
        line: 142
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 173,
            column: 12
          },
          end: {
            line: 173,
            column: 13
          }
        },
        loc: {
          start: {
            line: 174,
            column: 4
          },
          end: {
            line: 189,
            column: 6
          }
        },
        line: 174
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 197,
            column: 9
          },
          end: {
            line: 197,
            column: 10
          }
        },
        loc: {
          start: {
            line: 198,
            column: 4
          },
          end: {
            line: 207,
            column: 6
          }
        },
        line: 198
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 22,
            column: 2
          },
          end: {
            line: 24,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 22,
            column: 2
          },
          end: {
            line: 24,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 22
      },
      "1": {
        loc: {
          start: {
            line: 26,
            column: 2
          },
          end: {
            line: 28,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 26,
            column: 2
          },
          end: {
            line: 28,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 26
      },
      "2": {
        loc: {
          start: {
            line: 33,
            column: 2
          },
          end: {
            line: 37,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 33,
            column: 2
          },
          end: {
            line: 37,
            column: 3
          }
        }, {
          start: {
            line: 35,
            column: 9
          },
          end: {
            line: 37,
            column: 3
          }
        }],
        line: 33
      },
      "3": {
        loc: {
          start: {
            line: 35,
            column: 9
          },
          end: {
            line: 37,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 35,
            column: 9
          },
          end: {
            line: 37,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 35
      },
      "4": {
        loc: {
          start: {
            line: 72,
            column: 18
          },
          end: {
            line: 72,
            column: 43
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 72,
            column: 30
          },
          end: {
            line: 72,
            column: 38
          }
        }, {
          start: {
            line: 72,
            column: 41
          },
          end: {
            line: 72,
            column: 43
          }
        }],
        line: 72
      },
      "5": {
        loc: {
          start: {
            line: 74,
            column: 7
          },
          end: {
            line: 98,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 74,
            column: 8
          },
          end: {
            line: 74,
            column: 13
          }
        }, {
          start: {
            line: 74,
            column: 17
          },
          end: {
            line: 74,
            column: 25
          }
        }, {
          start: {
            line: 75,
            column: 8
          },
          end: {
            line: 97,
            column: 15
          }
        }],
        line: 74
      },
      "6": {
        loc: {
          start: {
            line: 79,
            column: 14
          },
          end: {
            line: 79,
            column: 37
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 79,
            column: 26
          },
          end: {
            line: 79,
            column: 32
          }
        }, {
          start: {
            line: 79,
            column: 35
          },
          end: {
            line: 79,
            column: 37
          }
        }],
        line: 79
      },
      "7": {
        loc: {
          start: {
            line: 80,
            column: 14
          },
          end: {
            line: 80,
            column: 37
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 80,
            column: 26
          },
          end: {
            line: 80,
            column: 28
          }
        }, {
          start: {
            line: 80,
            column: 31
          },
          end: {
            line: 80,
            column: 37
          }
        }],
        line: 80
      },
      "8": {
        loc: {
          start: {
            line: 82,
            column: 11
          },
          end: {
            line: 91,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 82,
            column: 11
          },
          end: {
            line: 82,
            column: 16
          }
        }, {
          start: {
            line: 83,
            column: 12
          },
          end: {
            line: 90,
            column: 20
          }
        }],
        line: 82
      },
      "9": {
        loc: {
          start: {
            line: 87,
            column: 21
          },
          end: {
            line: 87,
            column: 58
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 87,
            column: 34
          },
          end: {
            line: 87,
            column: 46
          }
        }, {
          start: {
            line: 87,
            column: 49
          },
          end: {
            line: 87,
            column: 58
          }
        }],
        line: 87
      },
      "10": {
        loc: {
          start: {
            line: 92,
            column: 11
          },
          end: {
            line: 96,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 92,
            column: 11
          },
          end: {
            line: 92,
            column: 19
          }
        }, {
          start: {
            line: 93,
            column: 12
          },
          end: {
            line: 95,
            column: 19
          }
        }],
        line: 92
      },
      "11": {
        loc: {
          start: {
            line: 100,
            column: 7
          },
          end: {
            line: 100,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 100,
            column: 7
          },
          end: {
            line: 100,
            column: 15
          }
        }, {
          start: {
            line: 100,
            column: 19
          },
          end: {
            line: 100,
            column: 53
          }
        }],
        line: 100
      },
      "12": {
        loc: {
          start: {
            line: 101,
            column: 7
          },
          end: {
            line: 105,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 101,
            column: 7
          },
          end: {
            line: 101,
            column: 17
          }
        }, {
          start: {
            line: 102,
            column: 8
          },
          end: {
            line: 104,
            column: 15
          }
        }],
        line: 101
      },
      "13": {
        loc: {
          start: {
            line: 115,
            column: 12
          },
          end: {
            line: 115,
            column: 89
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 115,
            column: 60
          },
          end: {
            line: 115,
            column: 72
          }
        }, {
          start: {
            line: 115,
            column: 75
          },
          end: {
            line: 115,
            column: 89
          }
        }],
        line: 115
      },
      "14": {
        loc: {
          start: {
            line: 115,
            column: 12
          },
          end: {
            line: 115,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 115,
            column: 12
          },
          end: {
            line: 115,
            column: 40
          }
        }, {
          start: {
            line: 115,
            column: 44
          },
          end: {
            line: 115,
            column: 57
          }
        }],
        line: 115
      },
      "15": {
        loc: {
          start: {
            line: 116,
            column: 12
          },
          end: {
            line: 116,
            column: 34
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 116,
            column: 27
          },
          end: {
            line: 116,
            column: 29
          }
        }, {
          start: {
            line: 116,
            column: 32
          },
          end: {
            line: 116,
            column: 34
          }
        }],
        line: 116
      },
      "16": {
        loc: {
          start: {
            line: 118,
            column: 13
          },
          end: {
            line: 118,
            column: 60
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 118,
            column: 32
          },
          end: {
            line: 118,
            column: 44
          }
        }, {
          start: {
            line: 118,
            column: 47
          },
          end: {
            line: 118,
            column: 60
          }
        }],
        line: 118
      },
      "17": {
        loc: {
          start: {
            line: 135,
            column: 21
          },
          end: {
            line: 135,
            column: 65
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 135,
            column: 21
          },
          end: {
            line: 135,
            column: 44
          }
        }, {
          start: {
            line: 135,
            column: 48
          },
          end: {
            line: 135,
            column: 65
          }
        }],
        line: 135
      },
      "18": {
        loc: {
          start: {
            line: 155,
            column: 9
          },
          end: {
            line: 163,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 155,
            column: 9
          },
          end: {
            line: 155,
            column: 49
          }
        }, {
          start: {
            line: 156,
            column: 10
          },
          end: {
            line: 162,
            column: 12
          }
        }],
        line: 155
      },
      "19": {
        loc: {
          start: {
            line: 159,
            column: 24
          },
          end: {
            line: 159,
            column: 62
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 159,
            column: 42
          },
          end: {
            line: 159,
            column: 51
          }
        }, {
          start: {
            line: 159,
            column: 54
          },
          end: {
            line: 159,
            column: 62
          }
        }],
        line: 159
      },
      "20": {
        loc: {
          start: {
            line: 202,
            column: 12
          },
          end: {
            line: 202,
            column: 67
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 202,
            column: 45
          },
          end: {
            line: 202,
            column: 55
          }
        }, {
          start: {
            line: 202,
            column: 58
          },
          end: {
            line: 202,
            column: 67
          }
        }],
        line: 202
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "0812619bc7eaa935fa341ae5abceb91ad8caa6c4"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_bjamgzyl = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_bjamgzyl();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { components, createFilter } from 'react-select';

// eslint-disable-next-line import/no-unresolved

import { Flex, Label, Text } from "../index.mjs";
import { ErrorPrompt } from "../../complex/ErrorPrompt/index.mjs";
import Icon from "../Icon/Icon.mjs";
export const ASSERT_NOT_NULL_ERROR = (cov_bjamgzyl().s[0]++, 'This field cannot be empty.');
export const OtherOption = (cov_bjamgzyl().s[1]++, {
  label: 'Other',
  value: 'other'
});
cov_bjamgzyl().s[2]++;
export const getAriaLabelledby = (ariaLabelledby, title, name) => {
  cov_bjamgzyl().f[0]++;
  cov_bjamgzyl().s[3]++;
  // Use aria-labelledby override for externally managed labels
  if (ariaLabelledby) {
    cov_bjamgzyl().b[0][0]++;
    cov_bjamgzyl().s[4]++;
    return ariaLabelledby;
  } else {
    cov_bjamgzyl().b[0][1]++;
  }
  // Otherwise labels only exists when a title prop is present
  cov_bjamgzyl().s[5]++;
  if (typeof title === 'string') {
    cov_bjamgzyl().b[1][0]++;
    cov_bjamgzyl().s[6]++;
    return title;
  } else {
    cov_bjamgzyl().b[1][1]++;
  }
  cov_bjamgzyl().s[7]++;
  return name;
};
cov_bjamgzyl().s[8]++;
const getOptionId = (ariaLabelledby, value, label) => {
  cov_bjamgzyl().f[1]++;
  cov_bjamgzyl().s[9]++;
  if (value === undefined) {
    cov_bjamgzyl().b[2][0]++;
    cov_bjamgzyl().s[10]++;
    return null;
  } else {
    cov_bjamgzyl().b[2][1]++;
    cov_bjamgzyl().s[11]++;
    if (typeof value !== 'string') {
      cov_bjamgzyl().b[3][0]++;
      cov_bjamgzyl().s[12]++;
      return "".concat(ariaLabelledby, "-").concat(label);
    } else {
      cov_bjamgzyl().b[3][1]++;
    }
  }
  cov_bjamgzyl().s[13]++;
  return "".concat(ariaLabelledby, "-").concat(value);
};
cov_bjamgzyl().s[14]++;
export const SelectWrapper = _ref => {
  let {
    flexDirection,
    title,
    subtitle,
    'aria-labelledby': ariaLabelledby,
    errorMsg,
    forId,
    isRequired,
    isDisabled,
    helperText,
    children
  } = _ref;
  cov_bjamgzyl().f[2]++;
  const isFlexRow = (cov_bjamgzyl().s[15]++, flexDirection === 'row');
  cov_bjamgzyl().s[16]++;
  return /*#__PURE__*/React.createElement(Flex, {
    className: "Select-input",
    flexDirection: flexDirection,
    alignItems: isFlexRow ? (cov_bjamgzyl().b[4][0]++, 'center') : (cov_bjamgzyl().b[4][1]++, '')
  }, ((cov_bjamgzyl().b[5][0]++, title) || (cov_bjamgzyl().b[5][1]++, subtitle)) && (cov_bjamgzyl().b[5][2]++, /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    pr: isFlexRow ? (cov_bjamgzyl().b[6][0]++, [3, 4]) : (cov_bjamgzyl().b[6][1]++, []),
    pb: isFlexRow ? (cov_bjamgzyl().b[7][0]++, []) : (cov_bjamgzyl().b[7][1]++, [2, 3])
  }, (cov_bjamgzyl().b[8][0]++, title) && (cov_bjamgzyl().b[8][1]++, /*#__PURE__*/React.createElement(Label, {
    htmlFor: forId,
    id: ariaLabelledby,
    required: isRequired,
    color: isDisabled ? (cov_bjamgzyl().b[9][0]++, 'neutrals70') : (cov_bjamgzyl().b[9][1]++, undefined)
  }, title)), (cov_bjamgzyl().b[10][0]++, subtitle) && (cov_bjamgzyl().b[10][1]++, /*#__PURE__*/React.createElement(Text, {
    className: "bricks__form-label--subtitle",
    fontSize: "s0",
    color: "neutrals100"
  }, subtitle)))), /*#__PURE__*/React.createElement(Flex, {
    flex: 1
  }, children), (cov_bjamgzyl().b[11][0]++, errorMsg) && (cov_bjamgzyl().b[11][1]++, /*#__PURE__*/React.createElement(ErrorPrompt, {
    message: errorMsg
  })), (cov_bjamgzyl().b[12][0]++, helperText) && (cov_bjamgzyl().b[12][1]++, /*#__PURE__*/React.createElement(Text, {
    fontSize: "s1",
    mt: 3,
    mb: 0
  }, helperText)));
};
cov_bjamgzyl().s[17]++;
export const DropdownIndicator = props => {
  cov_bjamgzyl().f[3]++;
  const smallVariant = (cov_bjamgzyl().s[18]++, props.selectProps.name.includes('small'));
  cov_bjamgzyl().s[19]++;
  return /*#__PURE__*/React.createElement(Icon, {
    "data-testid": "dropdown-indicator",
    name: (cov_bjamgzyl().b[14][0]++, props.selectProps.menuIsOpen) && (cov_bjamgzyl().b[14][1]++, !smallVariant) ? (cov_bjamgzyl().b[13][0]++, 'chevron-up') : (cov_bjamgzyl().b[13][1]++, 'chevron-down'),
    size: smallVariant ? (cov_bjamgzyl().b[15][0]++, 16) : (cov_bjamgzyl().b[15][1]++, 24),
    "aria-hidden": "true",
    color: props.isDisabled ? (cov_bjamgzyl().b[16][0]++, 'neutrals70') : (cov_bjamgzyl().b[16][1]++, 'neutrals100')
  });
};
export const createSelectFilter = (cov_bjamgzyl().s[20]++, createFilter({
  ignoreAccents: true,
  ignoreCase: true,
  matchFrom: 'any',
  trim: true
}));
cov_bjamgzyl().s[21]++;
export const getComponents = (ariaLabelledby, customDropdownIndicator, inputRef) => {
  cov_bjamgzyl().f[4]++;
  cov_bjamgzyl().s[22]++;
  return {
    DropdownIndicator: (cov_bjamgzyl().b[17][0]++, customDropdownIndicator) || (cov_bjamgzyl().b[17][1]++, DropdownIndicator),
    /**
     * Component has been customized to add complete a11y support for the select component.
     * @see https://github.com/JedWatson/react-select/issues/4062#issuecomment-872356845 for more details on what the current stance of react-select is.
     * @see https://github.com/JedWatson/react-select/pull/4322#issuecomment-749134033 for workaround
     */
    Option: props => {
      cov_bjamgzyl().f[5]++;
      cov_bjamgzyl().s[23]++;
      return /*#__PURE__*/React.createElement(components.Option, _extends({}, props, {
        innerProps: _objectSpread(_objectSpread({}, props.innerProps), {}, {
          role: 'option',
          'aria-disabled': props.isDisabled,
          'aria-selected': props.isFocused,
          id: getOptionId(ariaLabelledby, props?.['value'], props?.['label'])
        })
      }), props.children, (cov_bjamgzyl().b[18][0]++, props.selectProps.name.includes('small')) && (cov_bjamgzyl().b[18][1]++, /*#__PURE__*/React.createElement(Icon, {
        name: "checkmark",
        size: 12,
        visibility: props.isFocused ? (cov_bjamgzyl().b[19][0]++, 'visible') : (cov_bjamgzyl().b[19][1]++, 'hidden'),
        "float": "right",
        paddingTop: 3
      })));
    },
    /**
     * Component has been customized to add complete a11y support for the select component.
     * @see https://github.com/JedWatson/react-select/issues/4062#issuecomment-872356845 for more details on what the current stance of react-select is.
     * @see https://github.com/JedWatson/react-select/pull/4322#issuecomment-749134033 for workaround
     */
    MenuList: props => {
      cov_bjamgzyl().f[6]++;
      cov_bjamgzyl().s[24]++;
      return /*#__PURE__*/React.createElement(components.MenuList, _extends({}, props, {
        innerProps: _objectSpread(_objectSpread({}, props.innerProps), {}, {
          'aria-labelledby': ariaLabelledby,
          'aria-activedescendant': getOptionId(ariaLabelledby, props.focusedOption?.['value'], props.focusedOption?.['label']),
          id: "".concat(ariaLabelledby, "-options"),
          role: 'listbox',
          // MenuList is only rendered when the dropdown has been expanded
          'aria-expanded': true
        })
      }));
    },
    /**
     * Component has been customized to add complete a11y support for the select component.
     * @see https://github.com/JedWatson/react-select/issues/4062#issuecomment-872356845 for more details on what the current stance of react-select is.
     * @see https://github.com/JedWatson/react-select/pull/4322#issuecomment-749134033 for workaround
     */
    Input: props => {
      cov_bjamgzyl().f[7]++;
      cov_bjamgzyl().s[25]++;
      return /*#__PURE__*/React.createElement(components.Input, _extends({
        "aria-controls": "".concat(ariaLabelledby, "-options"),
        "aria-owns": "".concat(ariaLabelledby, "-options"),
        "aria-labelledby": ariaLabelledby,
        role: props.selectProps.isSearchable ? (cov_bjamgzyl().b[20][0]++, 'combobox') : (cov_bjamgzyl().b[20][1]++, 'listbox'),
        "aria-autocomplete": "list",
        innerRef: inputRef
      }, props, {
        "aria-haspopup": "listbox"
      }));
    }
  };
};